module.exports = __webpack_public_path__ + "static/media/ic_pdf.a63db73e.svg";